import { handleActions } from "redux-actions";

import {
    getInitialScrapeTasksStatistic,
    getInitialScrapeTasksStatisticSuccess,
    getInitialScrapeTasksStatisticError,
    clearInitialScrapeTasksStatistic
} from "modules/Scheduler/services/InitialScrapeTasksStatistic/actions";

const initialState = {
    isLoading: false,
    codes: [],
    starts: [],
    labels: [],
    statistic: []
};

export const initialScrapeTasksStatisticReducer = handleActions(
    {
        [clearInitialScrapeTasksStatistic]: () => ({ ...initialState }),

        [getInitialScrapeTasksStatistic]: (state) => ({
            ...state,
            isLoading: true
        }),
        [getInitialScrapeTasksStatisticSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getInitialScrapeTasksStatisticError]: (state) => ({
            ...state,
            isLoading: false
        })
    },
    initialState
);
